import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Input class=\"form-field__input\" placeholder={{this.placeholder}} disabled={{this.disabled}} />", {
  moduleName: "@dashboard/shared-ui/components/sq-field-input-social-security-number.hbs"
});